"use strict";

(function (a) {
    function _extends() { return _extends = Object.assign || function (a) { for (var b = 1; b < arguments.length; b++) { var c = arguments[b]; for (var d in c) Object.prototype.hasOwnProperty.call(c, d) && (a[d] = c[d]); } return a; }, _extends.apply(this, arguments); }

    var b;
    var c = {
        isMobile: !!a.Framework7,
        state: false
    };
    var d = a.jQuery;
    var e = (b = a.lodash) !== null && b !== void 0 ? b : a._;

    var f = function () {
        return ++this.value;
    }.bind({
        value: 0
    });

    var g = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
    var h = {
        images: a.Handlebars.compile('<div>' + '    {{#each images}}' + '    <img data-unique="{{unique}}" alt="{{title}}" data-src="{{url}}" src="{{#if @root.viewerConfig.navbar}}{{#if thumbnail}}{{thumbnail}}{{else}}{{url}}{{/if}}{{else}}{{@root.placeholderImage}}{{/if}}" />' + '    {{/each}}' + '</div>'),
        buttons: a.Handlebars.compile('{{#each buttons}}' + '<li tabindex="0" role="button" class="viewer-toolbar-custom{{#if customClass}} {{customClass}}{{/if}}" data-imageviewer-id="{{id}}" data-imageviewer-index="{{@index}}">' + '    <div{{#if icon}} style="background-image: url({{icon}});"{{/if}}></div>' + '</li>' + '{{/each}}')
    };

    var i = function fnWrapper(a, b, c) {
        return function () {
            var d = Array.from(arguments);
            d = d.concat(b == null ? void 0 : b.apply(this, d)), d = d.concat(a == null ? void 0 : a.apply(this, d)), c == null ? void 0 : c.apply(this, d);
        };
    };

    var j = function objFnWrapper(a, b, c, d) {
        a == null || b == null || (a[b] = i(a[b], c, d));
    };

    var k = function imageViewer(a) {
        var b = d.extend(true, {}, k.defaults, a);
        var c = b.el instanceof jQuery ? b.el : d(b.el);
        return c.length ? void c.on("click", "" + (b.triggerScope != null && b.triggerScope !== "" ? b.triggerScope + " " : "") + b.itemSelector, e.debounce(function (a) {
            var f = d(this);
            var g = f.data();
            var h = b.groupSelector ? f.parents(b.groupSelector) : [];
            !h.length && (h = c);
            var i = b.source ? b.source(f, h, b) : function () {
                    var a = e.chain(h.find(b.itemSelector)).map(function (a) {
                        var b = d(a).data();
                        return {
                            url: b.url,
                            title: b.title,
                            unique: b.unique,
                            data: b
                        };
                    }).filter("url").value();
                    return {
                        images: a,
                        selfIndex: e.findIndex(a, function (a) {
                            return a.url === g.url && (!g.title || g.title === a.title) && (!g.unique || g.unique === a.unique);
                        })
                    };
                }(),
                j = i.images,
                l = i.selfIndex;
            k.open(_extends({
                images: j,
                initialIndex: e.max([0, l])
            }, b)), a.stopPropagation(), a.stopImmediatePropagation(), a.preventDefault();
        }, 250, {
            leading: true,
            trailing: false
        })) : void console.warn("imageViewer需要一个正确的容器。");
    };

    k.defaults = {
        // el //事件依附元素（最高组）
        triggerScope: "",
        //触发范围
        groupSelector: ".imageViewer-container",
        //组容器选择器
        itemSelector: ".imageViewer-item" //组元素选择器
        // source: fn(item, group, configObj): { images: [{ url, title, unique, data }], selfIndex: number } //自定义数据源 使用该配置将跳过imageViewer自动收集图片列表
        //其余同imageViewer.open

    }, k.icons = {
        trashcan: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA+ElEQVQ4jeXTrUqEQRTG8d9Z/EAQxKJJwWC1GQxegFdgtRn0gqwWg0kQox8Ilm16AyaTWEQFFR1ZGJeXd9/ZXWXbPjAwnHnOn3mYM8ZP0S9xSmkdS2j9lvCAdkR8N/W0mooZtoMjzGM2rzkcYK/UN9EAWsQMNnGN85plrXOWUjrFa0Q8Vg97IqeU7vOtpnLpo2aZzMne8RwRy32BGbqNrVKsrMuIOBzg6QJP0mBdNfUWH6WifXziC7uDzMMAz/CGFxyPAvgnjRzYM4cNWsF0nojV/wJTZX9R2bcLnq5Kke+GuPltU7E02J3fsIGFAuwJNxFR/0VjJ/wALPtcB2pNjqEAAAAASUVORK5CYII="
    }, k.open = function (b) {
        var f, i, l, m;
        var n = d.extend(true, {}, k.open.defaults, b);

        if ((f = n.images) != null && f.length) {
            !n.viewerConfig && (n.viewerConfig = {}), n.viewerConfig.navbar = n.images.length > 1, n.viewerConfig.url = "data-src", n.viewerConfig.className = "imageViewer-viewer " + n.customClass, n.viewerConfig.initialViewIndex = n.initialIndex, n.viewerConfig = _extends({}, n.viewerConfig, (i = n.on) !== null && i !== void 0 ? i : {}), j(n.viewerConfig, "ready", function () {
                var a = d(p.viewer);
                return a.find(".viewer-toolbar ul").append(h.buttons({
                    buttons: n.buttons
                })), a.on("click", ".viewer-toolbar-custom", function () {
                    var a;
                    var b = d(this);
                    var c = b.data("imageviewerIndex");
                    c == null || ((a = n.buttons[c]) == null ? void 0 : a.onClick(p));
                }), p;
            }), j(n.viewerConfig, "hide", e.debounce(function () {
                var a, b;
                return c.isMobile && c.state && ((a = mainView) == null || (b = a.router) == null ? void 0 : b.back()), p;
            }, 250, {
                leading: true,
                trailing: false
            })), j(n.viewerConfig, "hidden", function () {
                return p.destroy(), o.remove(), p;
            });
            //initialize instance
            var o = d(h.images({
                images: n.images,
                viewerConfig: n.viewerConfig,
                placeholderImage: g
            }));
            var p = new a.Viewer(o[0], n.viewerConfig);
            return p.show(), c.isMobile && (c.state = true, (l = app) != null && (m = l.common) != null && m.dummyRoute({
                name: "imageViewer-route",
                on: {
                    close: function close() {
                        c.state = false, p.hide();
                    }
                }
            })), p.cfg = n, p.$dataSourceDom = o, p.removeImage = function (a) {
                var b;
                (b = o.children()[a]) == null ? void 0 : b.remove();
                var c = o.children().length;
                return c <= 0 ? p.hide() : (p.view(a >= c ? c - 1 : a + 1), p.index = a >= c ? c - 1 : a, p.viewed = true, p.update()), e.first(n.images.splice(a, 1));
            }, p;
        } //copy attributes and hook events

    }, k.open.defaults = {
        initialIndex: 0,
        //初始图片下标
        customClass: "",
        images: [],
        // { id, url, thumbnail, title }
        buttons: [],
        // { id, icon, customClass, onClick }
        on: {},
        // 事件
        viewerConfig: {
            //viewer 配置
            title: function title(a, b) {
                return "(" + b.naturalWidth + " \xD7 " + b.naturalHeight + ")";
            },
            toolbar: {
                zoomIn: true,
                zoomOut: true,
                oneToOne: false,
                reset: true,
                prev: true,
                play: false,
                next: true,
                rotateLeft: true,
                rotateRight: true,
                flipHorizontal: true,
                flipVertical: true
            },
            backdrop: "static",
            toggleOnDblclick: false,
            zIndex: 100000
        }
    }, a.imageViewer = k;
})(window);